module.exports = __webpack_public_path__ + "img/1920x793px.3b570529.png";